import type { SampleResponsePath } from './response-mapping';
import { addDiscoveredResponseFieldLabel, RESPONSE_MAPPING_COPY } from './response-mapping-copy';
import styles from './ResponseMapping.module.css';

interface DiscoveredResponseField extends SampleResponsePath {
  outputName: string;
}

interface DiscoveredResponseFieldsProps {
  suggestions: DiscoveredResponseField[];
  selectedPaths: Set<string>;
  onSelect: (path: string) => void;
}

export const DiscoveredResponseFields = ({
  suggestions,
  selectedPaths,
  onSelect,
}: DiscoveredResponseFieldsProps) => (
  <fieldset className={styles.discoveredFields}>
    <legend>{RESPONSE_MAPPING_COPY.discoveredFieldsLegend}</legend>
    <p>{RESPONSE_MAPPING_COPY.discoveredFieldsHint}</p>
    <div className={styles.discoveredFieldGrid}>
      {suggestions.map(suggestion => {
        const isSelected = selectedPaths.has(suggestion.path);
        return (
          <button
            key={suggestion.path}
            type="button"
            aria-pressed={isSelected}
            disabled={isSelected}
            onClick={() => onSelect(suggestion.path)}>
            <code>{suggestion.path}</code>
            <span>
              {isSelected
                ? RESPONSE_MAPPING_COPY.mappedFieldLabel
                : addDiscoveredResponseFieldLabel(suggestion.outputName)}{' '}
              · {suggestion.kind}
            </span>
          </button>
        );
      })}
    </div>
  </fieldset>
);
